import React from 'react'
import { useTheme } from '../Context/ThemeContext'
import Colors from './Colors'
import HeaderItem from './HeaderItem'
import Icon from './Icon'
import Logo from './Logo'
import Theme from './Theme'

function Header() {

    const { showSidebar, setShowSidebar } = useTheme();

    return (
        <div className='flex justify-between pt-2'>
            <div className=''>
                <Logo />
            </div>
            <div className='hidden md:flex justify-end items-center px-5'>
                <HeaderItem number='01.' title="Home" route='/' />
                <HeaderItem number='02.' title="About" route='/about' />
                <HeaderItem number='03.' title="Experience" route='/experience' />
                <HeaderItem number='04.' title="Works" route='/works' />
                <Colors />
                <Theme />
            </div>
            <div className='md:hidden flex justify-end items-center px-5'>
                <Icon className="fa-solid fa-bars cursor-pointer" onClick={() => setShowSidebar(!showSidebar)} />
            </div>
        </div>
    )
}

export default Header